module.exports = __webpack_public_path__ + "static/img/7.da7c941.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/premedical/7.png
// module id = 0EVN
// module chunks = 1